import Name from './Name';
import Project from './Project';
import Actions from './Actions';

export default {Name, Project, Actions};
